<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap class="custom-mb">
                <v-flex sm12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-toolbar-title>
                                <h3>
                                    AutoLoader
                                    <v-dialog v-model="autoLoaderInfoDialog" persistent max-width="500px">
                                        <v-icon style="font-size: 16px; line-height: 2; position: absolute; top: 6px;" slot="activator">info</v-icon>
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline">LOADMAX Autoloader Tool</span>
                                            </v-card-title>
                                            <v-card-text>
                                                In LOADMAX, you can upload a prefilled CSV file that includes all of the details of your loads into AUTOLOADER. When you either drag or upload your file, your loads will publish instantly and you can repost at any time.
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green white--text" text @click="autoLoaderInfoDialog = false">
                                                    Ok
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </h3>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <breadcrumbs :data="breadcrumbs" divider=">"></breadcrumbs>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-form encType="multipart/form-data">
                                <v-container grid-list-xl fluid>
                                    <v-layout row wrap class="formheadline">
                                        <v-flex lg6  xs12 >
                                            <!-- Upload loads CSV file here -->
                                            <v-dialog v-model="showEquipmentList" width="500px" scrollable transition="dialog-bottom-transition">
                                                <v-btn slot="activator" color="orange darken- white--text">
                                                    <v-icon>list</v-icon> &nbsp;&nbsp;Equipment List
                                                </v-btn>
                                                <v-card>
                                                    <v-toolbar dark color="orange">
                                                        <v-toolbar-title>Equipment List</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-btn icon dark @click="showEquipmentList=false">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-layout row wrap>
                                                            <v-flex lg12 md12 xs12>
                                                                <table width="100%" border="0" cellpadding="10px" class="custom_table">
                                                                    <tr>
                                                                        <th height="50px;">Id</th>
                                                                        <th>Name</th>
                                                                        <th>Code</th>
                                                                    </tr>
                                                                    <tr v-for="(equipment, index) in equipment_types" v-bind:key="index" class="tableSpace">
                                                                        <td height="50px;">{{equipment.id}}</td>
                                                                        <td>{{equipment.name}}</td>
                                                                        <td>{{equipment.code}}</td>
                                                                    </tr>
                                                                </table>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-dialog>
                                        </v-flex>
                                        <v-flex lg6  xs12 text-xs-right>
                                            <v-btn slot="activator" href="/static/loads.csv" download color="orange darken- white--text">
                                                <v-icon>fa fa-download</v-icon>  &nbsp;  &nbsp; CSV TEMPLATE
                                            </v-btn>
                                            <v-btn slot="activator" href="/static/loads.xlsx" download color="orange darken- white--text">
                                                <v-icon>fa fa-download</v-icon>  &nbsp;  &nbsp; EXCEL TEMPLATE
                                            </v-btn>
                                        </v-flex>
                                        <v-flex lg12 md12 customImgWrap>
                                            <div class="customImg" id="file-drag-drop">
                                                <form ref="myFiles">
                                                    <v-icon>cloud_upload</v-icon><br>
                                                    <p class="dragtxt">Drag files to upload</p>
                                                    <p class="ortxt">Or</p>
                                                    <v-btn slot="activator" color="orange darken- white--text" @click="$refs.inputUpload.click()">
                                                        <v-icon>search</v-icon>&nbsp;&nbsp;CHOOSE FILE
                                                    </v-btn>
                                                    <input v-show="false" ref="inputUpload" type="file" @change="onFileChange($event.target.files)" >
                                                    <br/><br/>
                                                    <p v-if="original_file_name != ''">
                                                        <strong class="link-text">     
                                                            File selected to upload loads :
                                                            <span>{{original_file_name}}</span>
                                                        </strong>
                                                    </p>
                                                </form>
                                            </div>
                                        </v-flex>
                                        <v-flex lg6 md12 xs12 v-model="fileError" v-if="fileError" id="fileErrorMessage">
                                            {{fileError}}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap>
                                        <v-flex lg12 md12 >
                                            <div class="form-btn text-xs-right">
                                                <v-btn color="gray  white--text" :to="{name:'Loads'}"> <v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                                <v-btn color="green white--text" @click="submit"><v-icon color="white">cloud_upload</v-icon> Upload </v-btn>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <GoogleAds></GoogleAds>
    </div>
</template>
<script>
import services from "../services/HttpService";
import breadcrumbs from "./widgets/Breadcrumb";
import axios from "axios";
import VWidget from '@/components/VWidget';
import UploadButton from 'vuetify-upload-button';
import GoogleAds from "@/pages/widgets/GoogleAds";
import {
    ErrorBag
} from 'vee-validate';

import {
    Validator
} from 'vee-validate';
import config from "../config";
export default {
    $_veeValidate: {
        validator: 'new'
    },
    data: () => ({
        canLeaveWithoutPrompt: false,
        files: [],
        original_file_name : '',
        equipment_types: [],
        showEquipmentList: false,
        fileError: null,
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                disabled: true
            },
            {
                name: 'AutoLoader',
                disabled: true
            }
        ],
        autoLoaderInfoDialog:false,
        dragAndDropCapable: false,
        validFileExtension:['csv','CSV','xls','XLS','xlsx','XLSX']
    }),
    components: {
        breadcrumbs,
        VWidget,
        GoogleAds,
        'upload-btn': UploadButton
    },
    mounted() {
        const self = this;
        self.$validator.localize('en', self.dictionary);
        this.dragAndDropCapable = this.determineDragAndDropCapable();
        if( this.dragAndDropCapable ){
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
                this.$refs.myFiles.addEventListener(evt, function(e){
                e.preventDefault();
                e.stopPropagation();
                }.bind(this), false);
            }.bind(this));
            this.$refs.myFiles.addEventListener('drop', function(e){
                this.onFileChange(e.dataTransfer.files);
            }.bind(this));
        }
    },
    created() {
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                services.get("equipments/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (equipment_types) {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (equipment_types.data.data.length > 0) {
                    equipment_types.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.id = data.id;
                        newArr.code = data.code;
                        self.equipment_types.push(newArr);
                    })
                } else {
                    self.showEquipmentTypes = false;
                }

            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
    },
    methods: {
        determineDragAndDropCapable(){
            var div = document.createElement('div');
            return ( ( 'draggable' in div )
                    || ( 'ondragstart' in div && 'ondrop' in div ) )
                    && 'FormData' in window
                    && 'FileReader' in window;
        },
        onFileChange(fileList) {
            if(fileList.length > 0){
                let fileName = fileList[0].name;
                let fileExtension = fileName.split('.').pop();
                if(this.validFileExtension.indexOf(fileExtension) == -1){
                    this._showToast('Incorrect File Format!', config.errMsgColorStr);
                    return false;
                }else{
                    this.original_file_name = fileList[0].name;
                    this.files.push(fileList[0]);
                }
            } else {
                this.original_file_name = '';
            }
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        submit() {
            const self = this;
            const wApp = window.getApp;
            if(self.files.length == 0 ){
                self._showToast(config.errAutoloader, config.errMsgColorStr);
                return false;
            }
            let fileFormData = new FormData();
            fileFormData.append('file',self.files[0]);
            let fileName = self.files[0].name;
            let fileExtension = fileName.split('.').pop();
            if (this.validFileExtension.indexOf(fileExtension) != -1) {
                self.$validator.validateAll()
                    .then(isValid => {
                        if (isValid) {
                            wApp.$emit("showLoader", {
                                show: true
                            });

                            services.postFile("loads/autoloader", fileFormData, {
                                'content-type': 'multipart/form-data',
                                "Authorization": "Bearer " + self.$store.state.user.token
                            })
                            .then(res => { 
                                wApp.$emit("showLoader", {
                                    show: false
                                });

                                if (!res.data.is_error) {
                                    self._showToast(res.data.message);
                                    self.canLeaveWithoutPrompt = true;
                                    self.fileError = null;
                                    fileFormData = new FormData();
                                    self.files = new Array();
                                    self.original_file_name = '';
                                    self.$router.push("/loads/list");
                                } else {
                                    self._showToast(res.data.message, config.errMsgColorStr);
                                    fileFormData = new FormData();
                                    self.files = new Array();
                                    self.original_file_name = '';
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                fileFormData = new FormData();
                                self.files = new Array();
                                self.original_file_name = '';
                                self._showToast(err.message, config.errMsgColorStr);
                            });
                        } else {
                            fileFormData = new FormData();
                            self.files = new Array();
                            self.original_file_name = '';
                            self._showToast('There are some invalid fields in the form. Please check!', "red");
                        }
                    })
            } else {
                self._showToast('Incorrect File Format!', config.errMsgColorStr);
                fileFormData = new FormData();
                self.files = new Array();
                self.original_file_name = '';
                return false;
            }
        }
    }
};
</script>
<style>
.v-btn{
    margin:0px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/AutoLoader.vue